<template>
  <div class="plpkp" style="height: 100%; width: 208px; background-color: rgba(52, 57, 64, 1);"
    :style="{ width: pd ? '208px' : 'auto' }">
    <div v-if="pd" class="logo">
      <img :src="logo" alt="logo" />
      <i class="el-icon-s-fold" @click="change()"></i>
      
    </div>
    <div class="logo_else" v-else>
      <i class="el-icon-s-unfold" @click="change1()"></i>
    </div>
    <div class="menu-content" :style="{ width: !pd ? '100%' : '208px' }">
      <ul class="w_nav" v-for="(item,i) in nav_list" :key="item.MenuID" v-bind:class="{ Menu_Selected: selectedPath === item.LinkURL || pselectedMenuID === item.MenuID, actives: isActive, 'text-danger': hasError, }">
        <li @click.stop="gourl(item)" :ref="'ref' + i" @mouseenter="moused">
          <i :class="item.Icon"></i>
          <span v-if="pd">{{ item.MenuName }}</span> 
          <span v-if="item.MenuName == '审批' && totalFlag" style="margin-left:110px;display: inline-block;width: 10px;height: 10px;background-color: red;border-radius: 50%;margin-top: 22px;"></span>
          <span v-if="item.MenuName == '危机干预' && urgentFlag" style="margin-left:110px;display: inline-block;width: 10px;height: 10px;background-color: red;border-radius: 50%;margin-top: 22px;"></span>

          <em v-if="item.children" class="el-icon-arrow-right"></em>
          <ul :class="['w_two',{'on':on}]" v-if="item.children">
            <li v-for="items in item.children" :key="items.MenuID" v-bind:class="{ Menu_Selected: selectedPath === items.LinkURL, actives: isActive, 'text-danger': hasError, }" @click.stop="gourl(items)">
              {{ items.MenuName }}
              <div class="bxiq" :class="noteList.consultLeavetQnty>0?'tb':'cd'" v-if="items.MenuName == '请假审批'">{{noteList.consultLeavetQnty}}</div>
              <div class="bxiq" :class="noteList.cancelAppointQnty>0?'tb':'cd'" v-if="items.MenuName == '取消预约审批'">{{noteList.cancelAppointQnty}}</div>
              <div class="bxiq" :class="noteList.relieveQnty>0?'tb':'cd'" v-if="items.MenuName == '解禁审批'">{{noteList.relieveQnty}}</div>
              <div class="bxiq" :class="noteList.consultingLongQnty>0?'tb':'cd'" v-if="items.MenuName == '长期咨询审批'">{{noteList.consultingLongQnty}}</div>
              <div class="bxiq" :class="noteList.consultBlackQnty>0?'tb':'cd'" v-if="items.MenuName == '限制名单审批'">{{noteList.consultBlackQnty}}</div>
              <div class="bxiq" :class="noteList.applyReportQnty>0?'tb':'cd'" v-if="items.MenuName == '报告查看审批'">{{noteList.applyReportQnty}}</div>
              <div class="bxiq" :class="noteList.userHistoryQnty>0?'tb':'cd'" v-if="items.MenuName == '激活审核'">{{noteList.userHistoryQnty}}</div>
              <div class="bxiq" :class="noteList.applyTestQnty>0?'tb':'cd'" v-if="items.MenuName == '测评审核'">{{noteList.applyTestQnty}}</div>
              <div class="bxiq" :class="noteList.consultantBlackQnty>0?'tb':'cd'" v-if="items.MenuName == '咨询师认证'">{{noteList.consultantBlackQnty}}</div>
              <div class="bxiq" :class="noteList.urgentPreQnty>0?'tb':'cd'" v-if="items.MenuName == '重点台账建立'">{{noteList.urgentPreQnty}}</div>
              <!-- <div class="tb">{{items.LineNumber}}</div> -->
              <!-- applyCommentQnty: 评论审核
                   applyReportQnty: 报告查看审批
                   applyTestQnty: 测评审核
                   cancelAppointQnty: 取消预约审批
                   consultBlackQnty: 限制名单审批
                   consultLeavetQnty: 请假审批
                   consultantBlackQnty: 咨询师审核
                   consultingLongQnty: 长期咨询审批
                   contentQnty: 帖子审核
                   eventQnty: 活动审批
                   materialQnty: 内容审核
                   relieveQnty: 解禁审批
                   userHistoryQnty: 激活审核 -->
            </li>
          </ul>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import NavItem from './NavItem'
import config from '../../public/config'
export default {
  data() {
    return {
      totalFlag:false,
      urgentFlag:false,
      noteList:'',
      RoleID:sessionStorage.getItem('RoleID'),
      isCollapse: true,
      logo: process.env.VUE_APP_URLs + 'File/PMS/logo/systemwhite.png',
      dee: sessionStorage.getItem('dee'),
      title: '北辰心理',
      pd: true,
      PMenuID: '',
      pselectedMenuID: '',
      selectedPath: '',
      isActive: true,
      hasError: false,
      nav_list: [],
      pageheight:window.innerHeight/2-50,
      on:false
    }
  },
  components: {
    NavItem,
  },

  created() {
    if (sessionStorage.getItem('entity') && sessionStorage.getItem('entity') != '') {
      this.selectedPath = sessionStorage.getItem('entity');
    } else if (sessionStorage.getItem('RealName') == '管理员') {
      this.selectedPath = '/index'
    } else {
      this.selectedPath = '/visitors/Waiting_test'
    }
  },
  methods: {
    moused(e) {
      this.on=this.pageheight<e.pageY?true:false
    },
    handleOpen(key,keyPath){},
    handleClose(key,keyPath){},
    change() {
      this.pd = false;
      this.isActive = false;
      this.hasError = true;
    },
    change1() {
      this.pd = true;
      this.isActive = true;
      this.hasError = false;
    },
    gourl(obj) {
      if (!(obj.children != undefined && obj.children != null && obj.children.length > 0)) {
        this.selectedPath = obj.LinkURL;
        this.$router.push(obj.LinkURL);
      }
    },

    GetExamineItemCount(){
      this.$Http_Post('ConsultSubscribe/GetExamineItemCount').then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.noteList = res.Data.notification;
          this.totalFlag = res.Data.totalFlag;
          this.urgentFlag=res.Data.urgentFlag;
          this.Global.notification=res.Data;
        }
      })
    },
  },
  mounted() {
    this.GetExamineItemCount();
    let _this = this;
    this.$Http_Post('User/GetRoleMenu',{PMenuID:'',RoleID:this.RoleID}).then((res) => {
      if (res.Code == 200 || res.Code == 0) {
        _this.nav_list = res.Data;
      }else if(res.Code==208){
        this.$router.push('/login');
      }
    });
  },
  watch: {
    //监听'
    $route(row) {
      if(row.path == '/Admin/ExamineLeave' || row.path == '/Admin/ExamineAppointment' || row.path == '/Admin/ExamineBan' || row.path == '/Admin/ExamineLongConsult'|| row.path == '/Admin/ExamineBlackList'|| row.path == '/Admin/ExamineConsultReport'|| row.path == '/Admin/ExamineRevision_review'|| row.path == '/Admin/ExamineTeamMeasure'|| row.path == '/Admin/CertifiedConsultant'){
        this.GetExamineItemCount()
      }
      let Object = {path: this['$route'].path,title: this['$route'].meta.title,name: this['$route'].name}
      this.pselectedMenuID = ''
      this.selectedPath = Object.path
      for (let i = 0; i < this.nav_list.length; i++) {
        if (this.nav_list[i].LinkURL.indexOf(this.selectedPath) > -1) {
          this.selectedPath = this.nav_list[i].LinkURL
          break
        }
        if (this.nav_list[i].children && this.nav_list[i].children.length > 0) {
          for (let j = 0; j < this.nav_list[i].children.length; j++) {
            if (this.nav_list[i].children[j].LinkURL.indexOf(this.selectedPath) > -1) {
              this.pselectedMenuID = this.nav_list[i].MenuID
              this.selectedPath = this.nav_list[i].children[j].LinkURL
              break
            }
          }
          if (this.pselectedMenuID != '') break
        }
      }
    },
  },
}
</script>
<style>

.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 200px;
  min-height: 400px;
}

.logo_else {
  width: 54px;
  height: 54px;
  font-size: 24px;
  background-color: rgba(0, 136, 255, 1);
  color: #fff;
  text-align: center;
  line-height: 54px;
}

.Menu_Selected {
  background-color: #409eff !important;
}

.menu-content {
  height: calc(100% - 54px);
}

.w_nav {
  width: 208px;
  background-color: rgba(54, 64, 77, 1);
  box-shadow: -1px 0px 0px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  position: relative;
}

.w_nav>li {
  height: 52px;
  border-bottom: 1px solid #444444;
  line-height: 52px;
  font-size: 14px;
  color: #fff;
  position: relative;
}

.w_nav>li span {
  position: absolute;
  left: 46px;
}

.w_nav>li em {
  position: absolute;
  right: 20px;
  top: 20px;
}

.w_nav>li:nth-child(1) i {
  height: 20px;
  width: 20px;
  display: inline-block;
  background-position: -20px -20px;
  position: absolute;
  left: 16px;
  font-size: 18px;
}

.w_nav>li:nth-child(2) i {
  height: 20px;
  width: 20px;
  display: inline-block;
  background-position: -20px -40px;
  position: absolute;
  top: 15px;
  left: 16px;
  font-size: 18px;
}

.w_nav>li:nth-child(3) i {
  height: 20px;
  width: 20px;
  display: inline-block;
  background-position: -20px -60px;
  position: absolute;
  top: 15px;
  left: 16px;
  font-size: 18px;
}

.w_nav>li:nth-child(4) i {
  height: 20px;
  width: 20px;
  display: inline-block;
  background-position: -20px -80px;
  position: absolute;
  top: 15px;
  left: 16px;
  font-size: 18px;
}

.w_nav>li:nth-child(5) i {
  height: 20px;
  width: 20px;
  display: inline-block;
  background-position: -20px -100px;
  position: absolute;
  top: 15px;
  left: 16px;
  font-size: 18px;
}

.w_nav>li:nth-child(6) i {
  height: 20px;
  width: 20px;
  display: inline-block;
  background-position: -20px -120px;
  position: absolute;
  top: 15px;
  left: 16px;
  font-size: 18px;
}

.w_nav>li:nth-child(7) i {
  height: 20px;
  width: 20px;
  display: inline-block;
  background-position: -20px -140px;
  position: absolute;
  top: 15px;
  left: 16px;
  font-size: 18px;
}

.w_nav>li:nth-child(8) i {
  height: 20px;
  width: 20px;
  display: inline-block;
  background-position: -20px -160px;
  position: absolute;
  top: 15px;
  left: 16px;
  font-size: 18px;
}

.w_nav>li:nth-child(9) i {
  height: 20px;
  width: 20px;
  display: inline-block;
  background-position: -20px -180px;
  position: absolute;
  top: 15px;
  left: 16px;
  font-size: 18px;
}

.w_nav>li:nth-child(10) i {
  height: 20px;
  width: 20px;
  display: inline-block;
  background-position: -20px -200px;
  position: absolute;
  top: 15px;
  left: 16px;
}

.logo {
  width: 100%;
  height: 54px;
  background-color: rgba(0, 136, 255, 1);
  position: relative;
  display: flex;
    align-items: center;
}

.logo img {
  width: 80%;
  height: 70%;
  margin-left: 6px;
}

.logo span {
  display: inline-block;
  color: #fff;
  font-size: 20px;
  font-weight: 600;
  position: absolute;
  top: 15px;
  left: 74px;
}

.logo i {
  width: 40px;
  height: 40px;
  display: inline-block;
  font-size: 24px;
  color: #fff;
  position: absolute;
  right: -6px;
  top: 18px;
}

.actives {
  width: 100%;
}

.text-danger {
  width: 54px;
}

.actives .w_two {
  background-color: rgba(52, 57, 64, 1);
  width: 120px;
  z-index: 100111111111111111;
  cursor: pointer;
  margin-left: 208px;
  position: relative;
  display: none;
  /* height: 40px; */
}

.actives .w_two.on{
  position: absolute;
  bottom: 0;
}

.text-danger .w_two {
  background-color: rgba(52, 57, 64, 1);
  width: 120px;
  z-index: 100111111111111111;
  display: none;
  cursor: pointer;
  margin-left: 53px;
  position: relative;
}

.text-danger .el-icon-arrow-right {
  display: none;
}

.w_two li {
  text-align: center;
  border-bottom: 1px solid #444444;
  width: 100%;
}

.w_two li:last-child{border:none;}

.w_nav li:hover {
  background-color: #66BFFF;
}

.w_nav li:hover ul {
  display: block;
}
.tb{display: inline-block;width: 16px;height: 17px;font-size: 10px;border-radius: 50%;background-color: red;color: #fff;text-align: center;margin-left: 6px;line-height: 18px;}
.cd{display: inline-block;width: 16px;height: 17px;font-size: 10px;border-radius: 50%;background-color: #959595;color: #fff;text-align: center;margin-left: 6px;line-height: 18px;}
</style>
